import React from "react";

import Loading from "../components/General/Loading.tsx";
import { DeploymentMapContainer } from "../components/Maps/DeploymentMap.tsx";

const HomePage = () => {
	return <DeploymentMapContainer />;
};

export default HomePage;
